<template>
  <footer class="footer-container">
    <div class="footer-content">
      <div class="left-section">
        <h2 class="company-name">{{$t("callme.companyName")}}</h2>
        <p class="desc">{{$t("callme.desc")}}</p>
        <button class="know-more-btn" @click="jump('/seven')">{{$t("button.learnMore")}}</button>
      </div>
      <div class="middle-section">
        <img
            src="@/assets/qr-code.png"
            alt="晴天集团二维码"
            class="qr-code"
        >
        <p class="qr-desc">{{$t("callme.qrDesc")}}</p>
      </div>
      <div class="right-section">
        <p class="contact-title">{{$t("callme.contactTitle")}}</p>
        <p class="address">{{$t("callme.address1")}}</p>
        <p class="address">{{$t("callme.address2")}}</p>
      </div>
    </div>
    <div class="footer-nav">
      <ul class="nav-list">
        <li class="nav-item"><a @click="jump('/home')">{{$t("nav.home")}}</a></li>
        <li class="nav-item"><a @click="jump('/about')">{{$t("nav.about")}}</a></li>
<!--        <li class="nav-item"><a href="#">{{$t("nav.message")}}</a></li>-->
        <li class="nav-item"><a @click="jump('/portfolio-companies/0')">{{$t("nav.portfolioCompanies")}}</a></li>
        <li class="nav-item"><a @click="jump('/four')">{{$t("nav.dynamic")}}</a></li>
        <li class="nav-item"><a @click="backlinks('http://www.hcccharitablefund.com/')">{{$t("nav.proBono")}}</a></li>
        <li class="nav-item"><a @click="jump('/seven')">{{$t("nav.contact")}} </a></li>
      </ul>
    </div>
    <div class="copyright">
      <p>{{$t("callme.copyright")}}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods:{
    jump(url){
      this.$router.push({path:url})
    },
    backlinks(url){
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
.footer-container {
  background-color: #794bb7;
  color: #fff;
  padding: 20px 0;
  border-top: 0.8rem solid #fccc0c;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 70%;
  margin: 0 auto;
}

.left-section,
.middle-section,
.right-section {
  flex: 1;
  margin-bottom: 20px;
  min-width: 200px;
  padding: 0 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.desc {
  margin-bottom: 20px;
  line-height: 1.6;
}

.know-more-btn {
  background-color: #fff;
  color: #7D3C98;
  border: none;
  padding: 8px 24px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: bolder;
}

.qr-code {
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto 10px auto;
}

.qr-desc {
  text-align: center;
  font-weight: bolder;
}

.contact-title {
  font-weight: bold;
  margin-bottom: 20px;
}

.address {
  line-height: 2;
  margin: 0;
}

.footer-nav {
  max-width: 70%;
  margin: 0 auto;
  border-bottom: 1px solid #dedede;
  padding-top: 10px;
}

.nav-list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.nav-item {
  margin: 8px 0;
  padding: 0 15px;
  position: relative;
  &:after {
    position: absolute;
    top: 3px;
    left: -10px;
    content: '';
    display: block;
    width: 1.5px;
    height: 14px;
    background-color: #dedede;
    margin: 0 10px;
  }
}

.nav-item:first-child {
  &:after {
    position: absolute;
    top: 3px;
    left: -10px;
    content: '';
    display: block;
    width: 0;
    height: 14px;
    background-color: #dedede;
    margin: 0 10px;
  }
}

.nav-item a {
  color: #fff;
  text-decoration: none;
}

.copyright {
  text-align: center;
  margin-top: 10px;
  font-size: 12px;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .left-section,
  .middle-section,
  .right-section {
    min-width: 100%;
    padding: 0;
  }

  .qr-code {
    margin: 0 auto 10px auto;
    width: 100px;
    height: 100px;
  }

  .nav-list {
    justify-content: center;
  }

  .know-more-btn {
    background-color: #fff;
    color: #7D3C98;
    border: none;
    padding: 8px 24px;
    cursor: pointer;
    border-radius: 4px;
    font-weight: bolder;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .qr-desc {
    text-align: center;
    font-weight: bolder;
    font-size: 12px;
  }

  .nav-item {
    margin: 8px 15px;
    &:after {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 14px;
      background-color: #dedede;
      margin: 0 10px;
    }
  }
  .footer-nav {
    max-width: 70%;
    margin: 0 auto;
    border-bottom: 1px solid #dedede;
    padding-top: 10px;
    margin-bottom: 10px;
  }
  .address {
    font-size: 12px;
  }
  .copyright {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .nav-item {
    margin: 8px 10px;
    font-size: 14px;
  }

  .company-name {
    font-size: 18px;
  }

  .desc {
    font-size: 14px;
  }

  .contact-title {
    font-size: 16px;
  }

  .address {
    font-size: 12px;
  }

  .copyright {
    font-size: 10px;
  }
}
</style>
